/** Shorten verbose Nominatim addresses for cards (dedupe repeated city names). */
export function formatShortAddress(full) {
  const raw = String(full ?? "").trim();
  if (!raw) return "—";

  const parts = raw
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);

  const unique = [];
  const seen = new Set();
  for (const part of parts) {
    const key = part.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    unique.push(part);
  }

  if (unique.length <= 4) return unique.join(" · ");
  return `${unique.slice(0, 3).join(" · ")} · ${unique[unique.length - 1]}`;
}
